import React from 'react'
import Page from 'components/Page'

const _403 = () => (
  <Page title="Unauthorised">
    <p>You are not authorised to view</p>
  </Page>
)

export default _403
